import React, { Component } from "react";
import client from "@culturehq/client";
import { Button, Loader, Pagination, Table, Warning } from "@culturehq/components";

import { useFieldsLabels } from "app/hooks";
import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";

import { createEntity, updateEntity, deleteEntity } from "./mutations";
import CompanyRow from "./companies/CompanyRow";
import CompanyModal from "./companies/CompanyModal";

const createCompany = createEntity("companies");
const updateCompany = updateEntity("companies");
const deleteCompany = deleteEntity("companies");

class CompaniesContext extends Component {
  state = { loading: true, companies: [] };

  componentDidMount() {
    const { match } = this.props;

    this.fetchCompanies(match.params.page || 1);
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;

    if (match.params.page !== prevProps.match.params.page) {
      this.fetchCompanies(match.params.page || 1);
    }
  }

  handlePageClick = page => {
    const { history } = this.props;

    history.push(`/admin/companies/${page}`);
  };

  handleCreate = company => {
    this.setState(createCompany(company));
  };

  handleUpdate = company => {
    this.setState(updateCompany(company));
  };

  handleDelete = company => {
    this.setState(deleteCompany(company));
  };

  async fetchCompanies(page) {
    this.setState({ loading: true });

    const { companies, pagination } = await client.listCompanies({ page });

    this.setState({ loading: false, companies, pagination });
  }

  render() {
    const { companies, loading, pagination } = this.state;
    const { labels: { companies: { singular, plural } } } = this.props;

    return (
      <div className="padding-left-15px padding-right-15px">
        <PageHeader title={t(`Manage ${plural}`)}>
          <Trans>
            The below is a list of all the {plural.toLocaleLowerCase()} at your organization
            created by admins or users. They will appear in a pre-set list to
            choose from on their profile page. Users may also create a new
            {" "}{singular.toLocaleLowerCase()} on their profile page. If you are uploading a CSV file,
            then the {plural.toLocaleLowerCase()} listed in there will override any existing
            {" "}{singular.toLocaleLowerCase()} a user has selected.
          </Trans>
        </PageHeader>

        <CompanyModal onCreate={this.handleCreate}>
          {onTrigger => (
            <Button icon="plus" primary onClick={onTrigger}>
              <Trans>Add a {singular}</Trans>
            </Button>
          )}
        </CompanyModal>

        <Loader loading={loading}>
          <Table>
            <thead>
              <tr>
                <th>{singular} Name</th>
                <th>Created</th>
                <th>Updated</th>
                <th className="actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              {companies.map(company => (
                <CompanyRow
                  key={company.id}
                  company={company}
                  onUpdate={this.handleUpdate}
                  onDelete={this.handleDelete}
                />
              ))}
            </tbody>
          </Table>

          {companies.length < 1 && (
            <Warning>
              <strong>Uh oh!</strong> No results to show.
            </Warning>
          )}

          <Pagination {...pagination} onClick={this.handlePageClick} />
        </Loader>
      </div>
    );
  }
}

const Companies = props => {
  const labels = useFieldsLabels();

  return <CompaniesContext {...props} labels={labels} />;
};

export default Companies;
